<template>
  <div class="promo-top">
    <h1>PROMOSYONLAR</h1>
    <p>{{ $store.getters['getClientMeta'].name }} birbirinden eşsiz ve zengin promosyonları sizleri bekliyor.</p>
    <div class="promo-menu">
        <h1>
          Size Özel Avantajlar
        </h1>
        <ul>
          <li>
            <a href="javascript:;" @click="changeGroup('all')" :class="{'active' : activeGroup == 'all'}">
              Hepsi
            </a>
          </li>
          <li v-for="item,key in groups">
            <a href="javascript:;" @click="changeGroup(key)" :class="{'active' : activeGroup == key}">
              {{ item.name }}
            </a>
          </li>
        </ul>
    </div>
  </div>
</template>
<script>
    export default{
      props:['activeGroup','groups'],
      data(){
        return{

        }
      },
      methods:{
          changeGroup(group){
            this.$emit('Group', group)
          }
      }
    }
</script>

<style lang="scss">
  #app.mobile .promo-menu{
    ul{
      white-space: nowrap;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
    }
  }
</style>